const noAlcoholCategories = [
  'No Alcohol',
  'Cigarettes & Tobacco',
  'Alcohol Free',
  'Non-Alcoholic Distilled Drinks',
  'Tonic Water & Mixers',
  'Tonic Water',
];

function isNotInAlcoholExclusionCategory(category) {
  return Array.isArray(category.tags) && !(category.tags.find(tag =>
    noAlcoholCategories.includes(tag.name)));
}

function isInMainAlcoholCategory(category) {
  return Array.isArray(category.tags)
    && category.tags.length >= 0 && category.tags[0].name === 'Beer, Wine & Spirits';
}

export const isAlcohol = (categories) => (
  categories.every(isNotInAlcoholExclusionCategory) &&
  categories.some(isInMainAlcoholCategory)
);
